import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { setAuth } from '../../redux/authSlice';
import { RootState } from '../../redux/store';
import { useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Tooltip from '@mui/material/Tooltip';
import '../i18n/i18n';
import { useTranslation } from 'react-i18next';
import {
  faLayerGroup,
  faGear,
  faToolbox,
  faUserGroup,
  faCalendarCheck,
  faCommentDollar,
  faHashtag,
  faFolderOpen,
  faAddressBook,
  faGraduationCap,
  faHardDrive,
  faHouse,
  faListCheck,
} from '@fortawesome/free-solid-svg-icons';

interface NavProps {
  access: any
}

const Nav: React.FC<NavProps> = ({ access }) => {
  const auth = useSelector((state: RootState) => state.auth.value);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const logout = async () => {
    try {
      await axios.post('logout', {}, { withCredentials: true });
      axios.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('authToken');
      dispatch(setAuth(false));
      navigate('/login');
    } catch {}
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('user');
        if (data) {
          dispatch(setAuth(true));
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        // auth errors are handled by the global interceptor
      }
    };
    if (auth) {
      fetchData();
    }
  }, [auth, dispatch]);

  const menuItems = [
    { name: "/dashboard",  path: "/dashboard",  label: "Dashboard",  icon: faHouse,        iconBg: 'rgba(37,99,235,.15)',   noAccessCheck: true },
    { name: "/timesheets", path: "/timesheets", label: "Timesheets", icon: faLayerGroup,    iconBg: 'rgba(16,185,129,.15)',  noAccessCheck: true },
    { name: "/docs",       path: "/docs",       label: "Docs",       icon: faFolderOpen,    iconBg: 'rgba(14,165,233,.15)',  accessKey: "document_view",     accessValue: 0,     size: '>' },
    { name: "/crm",        path: "/crm",        label: "CRM",        icon: faAddressBook,   iconBg: 'rgba(236,72,153,.15)',  accessKey: "crm_contacts_get",  accessValue: 0,     size: '>' },
    { name: "/tasks",      path: "/tasks",      label: "TasksNav",   icon: faListCheck,     iconBg: 'rgba(99,102,241,.15)',  accessKey: "tasks_enabled",     accessValue: false, size: 'bool' },
    { name: "/equipment",  path: "/equipment",  label: "Equipment",  icon: faToolbox,       iconBg: 'rgba(245,158,11,.15)',  accessKey: "equipment_view_all",accessValue: 0,     size: '>' },
    { name: "/training",   path: "/training",   label: "Training",   icon: faGraduationCap, iconBg: 'rgba(16,185,129,.15)',  accessKey: "training_view",     accessValue: false, size: 'bool' },
    { name: "/finance",    path: "/finance",    label: "Finance",    icon: faCommentDollar, iconBg: 'rgba(124,58,237,.15)' },
    { name: "/hr",         path: "/hr",         label: "HR",         icon: faUserGroup,     iconBg: 'rgba(236,72,153,.15)',  accessKey: "users_view",        accessValue: 0,     size: '>' },
  ];

  const isMenuActive = (path: any) => location.pathname === path;

  let li;

  if (auth && access) {
    li = (
      <ul className='flex gap-[2px] flex-col decoration-none normal-case list-none py-[4px] w-full'>
        {menuItems
          .slice(0, 9)
          .map(({ name, path, label, icon, iconBg }: any) => {
            let hasAccess = false;
            if (path === '/dashboard') {
              hasAccess = access.dashboard_enabled === true;
            } else if (path === '/timesheets') {
              hasAccess = access.timesheets_enabled === true;
            } else if (path === '/equipment') {
              hasAccess = access.equipment_enabled === true;
            } else if (path === '/finance') {
              hasAccess = access.finance_enabled === true;
            } else if (path === '/docs') {
              hasAccess = access.docs_enabled === true;
            } else if (path === '/settings') {
              hasAccess = access.settings_enabled === true;
            } else if (path === '/hr') {
              hasAccess = access.hr_enabled === true;
            } else if (path === '/crm') {
              hasAccess = access.crm_enabled === true;
            } else if (path === '/tasks') {
              hasAccess = access.tasks_enabled === true;
            } else if (path === '/training') {
              hasAccess = access.training_enabled === true;
            }
            return (
              hasAccess && (
                <Link
                  to={path}
                  key={name}
                  className={`nav-item-new ${isMenuActive(path) ? 'nav-active' : ''}`}>
                  <li style={{ listStyle: 'none', display: 'contents' }}>
                    <div className="nav-ic-tile" style={{ background: iconBg }}>
                      <FontAwesomeIcon
                        icon={icon}
                        style={{ fontSize: 16, color: 'var(--text-new)', opacity: isMenuActive(path) ? 1 : 0.7 }} />
                    </div>
                    <span className="nav-ic-label">{t(label)}</span>
                    <span className="nav-tooltip">{t(label)}</span>
                  </li>
                </Link>
              )
            );
          })}
        <li className='list-none'><div className="nav-sep" /></li>
        {menuItems
          .slice(9)
          .map(({ name, path, label, icon, iconBg }: any) => {
            let hasAccess = false;
            if (path === '/finance') {
              hasAccess = access.finance_enabled === true;
            } else if (path === '/settings') {
              hasAccess = access.settings_enabled === true;
            } else if (path === '/hr') {
              hasAccess = access.hr_enabled === true;
            }
            return (
              hasAccess && (
                <Link
                  to={path}
                  key={name}
                  className={`nav-item-new ${isMenuActive(path) ? 'nav-active' : ''}`}>
                  <li style={{ listStyle: 'none', display: 'contents' }}>
                    <div className="nav-ic-tile" style={{ background: iconBg }}>
                      <FontAwesomeIcon
                        icon={icon}
                        style={{ fontSize: 16, color: 'var(--text-new)', opacity: isMenuActive(path) ? 1 : 0.7 }} />
                    </div>
                    <span className="nav-ic-label">{t(label)}</span>
                    <span className="nav-tooltip">{t(label)}</span>
                  </li>
                </Link>
              )
            );
          })}
      </ul>
    );
  } else {
    li = (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {auth && (
        <div className='nav-box left-0 top-[55px] z-50 w-[76px]'>
          <div className='flex flex-col items-center h-full w-full'>
            <div className="w-full ul-no-scroll" style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
              {li}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Nav